import React from 'react';
import { generatePlatformSettingsTabs } from '../platformSettingsTabUtils';

export const PLATFORM_TAB_GROUP_ID = 'platform';

const PLATFORM_TAB_COMPONENTS_BY_ID = {
  general: React.lazy(() => import('./General/GeneralSettings')),
  brand: React.lazy(() => import('./Brand/BrandSettings')),
  holidays: React.lazy(() => import('./Holidays/HolidaysSettings')),
  'full-time-equivalent': React.lazy(() => import('./FullTimeEquivalent/FullTimeEquivalentSettings')),
  'sickness-reporting': React.lazy(() => import('./SicknessReporting/SicknessReportingSettings')),
  calendar: React.lazy(() => import('./Calendar/CalendarSettings')),
  gdpr: React.lazy(() => import('./Gdpr/GdprSettings')),
  sso: React.lazy(() => import('./Sso/SsoSettings')),
  'company-links': React.lazy(() => import('./CompanyLinks/CompanyLinksSettingsTab')),
  'upload-data': React.lazy(() => import('./UpdateData/UploadData')),
};

export const PLATFORM_TABS = generatePlatformSettingsTabs(PLATFORM_TAB_COMPONENTS_BY_ID, PLATFORM_TAB_GROUP_ID);
